import { React } from '../../../lib';
import { ToolbarNew } from '../toolbar';
export const ChatToolbar = (props) => (React.createElement(ToolbarNew, { className: "group/chat-toolbar border-b border-[oklch(var(--chat-l-text)_0_0_/_0.12)] !bg-[oklch(var(--chat-l-surface)_0_0_/_0.94)]", lhs: [
        {
            type: 'raw-jsx',
            width: 440,
            importance: 90,
            content: (React.createElement("div", { className: "flex min-w-0 items-center gap-1.5" },
                React.createElement("span", { title: props.selectedThreadTitle, className: "flex-1 min-w-0 truncate text-[16px] font-semibold leading-6 text-[oklch(var(--chat-l-text)_0_0)]" }, props.selectedThreadTitle),
                React.createElement("button", { type: "button", title: "Rename thread", "aria-label": "Rename thread", onClick: props.renameSelectedThread, disabled: !props.canMutateSelectedThread, className: "mt-px inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-sm border border-transparent opacity-100 transition-opacity md:opacity-0 md:group-hover/chat-toolbar:opacity-100 md:group-focus-within/chat-toolbar:opacity-100 focus:opacity-100 hover:bg-[oklch(var(--chat-l-surface-bubble)_0_0)] hover:border-[oklch(var(--chat-l-text)_0_0_/_0.22)] disabled:pointer-events-none disabled:opacity-30" },
                    React.createElement("img", { alt: "Rename thread", src: "/static/img/i8/ios16-pencil.svg", className: "h-3 w-3" })))),
            overflowOverride: {
                label: 'Rename thread',
                labelDesc: props.selectedThreadTitle,
                icon: '/static/img/i8/ios16-pencil.svg',
                onClick: props.renameSelectedThread,
            },
        },
    ], rhs: [
        {
            type: 'button-24',
            width: 88,
            importance: 120,
            lbl: props.toggleThreadButtonLabel,
            img: props.toggleThreadActionIcon,
            title: props.toggleThreadActionLabel,
            'aria-label': props.toggleThreadActionLabel,
            onClick: props.confirmToggleThreadResolved,
            disabled: !props.canMutateSelectedThread,
        },
    ] }));
//# sourceMappingURL=toolbar.js.map